import { NavItem, NavItemProps } from "./NavItem";

interface NavLinkItemProps extends Omit<NavItemProps, "kind" | "url"> {
  kind?: "NavLinkItemElement";
  url: string;
}
export function NavLinkItem(props: NavLinkItemProps) {
  return <NavItem {...props} />;
}
